import { module } from 'angular';

import { default as indicatorColorFilterName, IndicatorColorFilter } from './filter/indicator-color.filter';
import { default as indicatorUnitFilterName, IndicatorUnitFilter } from './filter/indicator-unit.filter';
import { default as indicatorListName, IndicatorList } from './indicator-list.component.ajs';

export default module('contact.wallboard.configuration.indicator-list', [])
  .component(indicatorListName, new IndicatorList())
  .filter(indicatorColorFilterName, IndicatorColorFilter)
  .filter(indicatorUnitFilterName, IndicatorUnitFilter).name;
